import React, { useState, Fragment } from 'react'
import cx from 'classnames'

export const Tabs = (props) => {
  const children = React.Children.toArray(props.children).filter((child) => !child.props.hidden)

  const [activeTab, setActiveTab] = useState(children[0]?.props.title)

  if (!children.length) {
    return null
  }

  return (
    <Fragment>
      {children.length > 1 && (
        <ul className='nav nav-tabs'>
          {children.map((child) => {
            const title = child.props.title

            return (
              <li className='nav-item' key={child.key} onClick={() => setActiveTab(title)}>
                <a className={cx('nav-link', { active: title === activeTab })}>{title}</a>
              </li>
            )
          })}
        </ul>
      )}

      <div className='tab-content'>
        {children.map((child) => {
          const title = child.props.title

          if (title !== activeTab) {
            return null
          }

          return (
            <div className='tab-pane active' role='tabpanel' key={child.key}>
              {child}
            </div>
          )
        })}
      </div>
    </Fragment>
  )
}

export const Tab = ({ children }) => {
  return children
}
